import { Position, PositionCode } from "../../../../../../constants";
import { DateHelper, StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";
import { isInGroup } from "../../pages/absence-letter/absence-letter-create";
import { getUnitCode } from "../../utils";

export const form21 = (record: any) => {
  const [depCode, department] = StringHelper.verticalBarSplit(record.eBranch);
  const isKCQ = depCode === "KCQ";

  const dayOff = DateHelper.duration(record?.eVacationPeriods).days();
  const [position] = StringHelper.verticalBarSplit<[Position]>(record.eTitle);
  const isNotPresidentApproval =
    dayOff < 3 &&
    isInGroup(position, [PositionCode.DT, PositionCode.PP, PositionCode.PTT]) &&
    isKCQ;

  const salutationValue = isNotPresidentApproval
    ? [`Trưởng ${StringHelper.verticalBarSplit(record?.eDepartment)[1]}`]
    : [
        "Tổng Giám đốc.",
        `Trưởng ${StringHelper.verticalBarSplit(record?.eDepartment)[1]}`,
      ];
  return {
    departmentCode: depCode,
    aflType: AFLType.ApplicationForLeave,
    layout: [
      {
        type: "header",
        value: {
          form: 2,
          department: isKCQ
            ? StringHelper.verticalBarSplit(record?.eDepartment)[1]
            : department,
          requestId: record.id,
          unitCode: getUnitCode(record),
        },
      },
      {
        type: "title",
        value: {
          sub: ["(Dành cho Cán bộ Phó Trưởng Phòng/Trung tâm, Đội trưởng)"],
        },
      },
      {
        type: "salutation",
        value: salutationValue,
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          {
            type: "ePosition",
            value: StringHelper.verticalBarSplit(record?.eTitle)[1],
          },
          {
            type: "eWorkPlace",
            value: `${StringHelper.verticalBarSplit(record?.eTeam)[1]} - ${
              StringHelper.verticalBarSplit(record?.eDepartment)[1]
            }`,
          },
          {
            type: "",
            value: `Nay tôi làm đơn này kính đề nghị Ông Trưởng phòng, trung tâm đồng ý giải quyết cho tôi được nghỉ phép năm ${new Date().getFullYear()}. lần thứ ${
              record?.ePaidLeaveTimes || ""
            }.`,
          },
          {
            type: "",
            value: `Số lượng phép theo tiêu chuẩn: ${record?.ePaidLeaveRemain} ngày (trong TH nghỉ phép từ lần thứ 2 trở đi, chỉ ghi rõ số ngày phép còn lại chưa thực hiện).`,
          },

          {
            type: "eVacationPeriods",
            value: record?.eVacationPeriods,
            docxType: "paragraph",
          },
          { type: "eLeavePlace", value: record?.eLeavePlace },
          { type: "ePhoneNumber", value: record?.ePhone },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value: `Rất mong nhận được sự chấp thuận của ${
              dayOff < 3
                ? "Trưởng phòng, trung tâm"
                : "Tổng Giám đốc/Trưởng phòng, trung tâm"
            }.`,
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", `- Lưu ${getUnitCode(record)}.`],
          },
          {
            type: "signature1",
            value: ["THỦ TRƯỞNG ĐƠN VỊ", record?.eSteps[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      ...(!isNotPresidentApproval
        ? [
            {
              type: "footer",
              value: [
                {
                  type: "signature1",
                  value: [
                    "PHÊ DUYỆT CỦA TỔNG GIÁM ĐỐC",
                    record?.eSteps[2][0].name,
                  ],
                },
              ],
              textBreak: 3,
            },
          ]
        : []),
    ],
  };
};
